// extracted by mini-css-extract-plugin
export default {"noteContainer":"FormNotes_noteContainer__XZXwN","notesDiv":"FormNotes_notesDiv__IZKMu"};